import { render, staticRenderFns } from "./AdminServiceAreaAttributeList.vue?vue&type=template&id=b42b0118"
import script from "./AdminServiceAreaAttributeList.vue?vue&type=script&lang=js"
export * from "./AdminServiceAreaAttributeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports